/* eslint-disable no-unused-vars */
import Vue from 'vue';
import axios from 'axios';
import Vuex from 'vuex';

Vue.use(Vuex);
export default {
  state: {
    users: [],
    AdminLogin: null
  },
  getters: {
    GetAllUsers(state) {
      return state.users;
    },
    IsAdminLogin(state) {
      state.AdminLogin = localStorage.getItem('user-info');
      return state.AdminLogin;
    }
  },
  actions: {
    async getUsers({ commit }, payload) {
      // .get(`${process.env.VUE_APP_API_URL}api/User/GetUsers`, {
      //return await axios.get('https://localhost:44395/api/Teachers/GetUserslist', payload).then((res) => {
      return await axios.get('http://almaapis.rootpointers.net/api/Teachers/GetUserslist', payload).then((res) => {
        commit('AllUsers', res.data.data);
      });
    },
    async LoginAdmin({ commit }, payload) {
      return await axios.post('http://almaapis.rootpointers.net/api/Accounts/AdminLogin', payload).then((res) => {
        commit('setAdmin', res.data);
        return res.data;
      });
    },
    async Logout({ commit }, payload) {
      commit('setAdmin', localStorage.removeItem('user-info'));
    }
  },
  mutations: {
    AllUsers(state, payload) {
      state.users = payload;
    },
    setAdmin(state, payload) {
      state.AdminLogin = payload;
    }
  }
};
